import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

function scrollBehavior() {
  return { x: 0, y: 0 };
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/:type?/article/:id?",
      name: "article",
      component: () => import("@/views/ArticlePage.vue"),
    },
    {
      path: "/news",
      name: "news",
      component: () => import("@/views/News.vue"),
    },
    {
      path: "/activity",
      name: "activity",
      component: () => import("@/views/Activities.vue"),
    },
    {
      path: "calendar",
      name: "calendar",
      component: () => import("@/views/Calendar.vue"),
    },
    {
      path: "shops",
      name: "shops",
      component: () => import("@/views/Shops.vue"),
    },
    {
      path: "/intro",
      name: "intro",
      component: () => import("@/views/Intro.vue"),
      children: [
        {
          path: "purpose",
          name: "intro-purpose",
          component: () => import("@/views/IntroPurpose.vue"),
        },
        {
          path: "rule",
          name: "intro-rule",
          component: () => import("@/views/IntroRule.vue"),
        },
        {
          path: "pastchairmans",
          name: "intro-pastchairmans",
          component: () => import("@/views/IntroChairmans.vue"),
        },
        {
          path: "staffs",
          name: "intro-staffs",
          component: () => import("@/views/IntroStaffs.vue"),
        },
        {
          path: "advisors",
          name: "intro-advisors",
          component: () => import("@/views/IntroAdvisors.vue"),
        },
      ],
    },
    {
      path: "/docs/official_docs",
      name: "official_docs",
      component: () => import("@/views/OfficialDocs.vue"),
    },
    {
      path: "/docs/applications",
      name: "applications",
      component: () => import("@/views/Applications.vue"),
    },
    {
      path: "/talks/15-1",
      name: "talks-15-1",
      component: () => import("@/talks/talks-15-1.vue"),
    },
    {
      path: "/talks/15-2",
      name: "talks-15-2",
      component: () => import("@/talks/talks-15-2.vue"),
    },
    {
      path: "/talks/16-1",
      name: "talks-16-1",
      component: () => import("@/talks/talks-16-1.vue"),
    },
    {
      path: "/talks/16-2",
      name: "talks-16-2",
      component: () => import("@/talks/talks-16-2.vue"),
    },
    {
      path: "/talks/17-1",
      name: "talks-17-1",
      component: () => import("@/talks/talks-17-1.vue"),
    },
    {
      path: "/talks/18-1",
      name: "talks-18-1",
      component: () => import("@/talks/talks-18-1.vue"),
    },
    {
      path: "*",
      redirect: { name: "home" },
    },
  ],
});
